import { gql } from "@apollo/client";

// Get FUB Settings for a company
export const GET_FUB_SETTINGS = gql`
  query getFubSettings($companyId: String!) {
    getFubSettings(companyId: $companyId) {
      _id
      company {
        _id
        companyName
      }
      isConnected
      isSyncing
      lastSyncAt
      lastSyncStatus
      lastSyncError
      activeStages
      closedStages
      ignoreStages
      totalBuyersImported
      createdAt
      updatedAt
    }
  }
`;

// Get FUB Sync Status
export const GET_FUB_SYNC_STATUS = gql`
  query getFubSyncStatus($companyId: String!) {
    getFubSyncStatus(companyId: $companyId) {
      isRunning
      progress
      totalToSync
      currentlySyncing
      errors
    }
  }
`;

// Test FUB Connection
export const TEST_FUB_CONNECTION = gql`
  query testFubConnection($apiKey: String!) {
    testFubConnection(apiKey: $apiKey) {
      success
      message
      accountInfo
    }
  }
`;

// Connect to FUB
export const CONNECT_FUB = gql`
  mutation connectFub($companyId: String!, $apiKey: String!) {
    connectFub(companyId: $companyId, apiKey: $apiKey) {
      success
      message
      settings {
        _id
        isConnected
        activeStages
        closedStages
        ignoreStages
      }
      importStarted
    }
  }
`;

// Disconnect from FUB
export const DISCONNECT_FUB = gql`
  mutation disconnectFub($companyId: String!) {
    disconnectFub(companyId: $companyId) {
      success
      message
      buyersRemoved
    }
  }
`;

// Update FUB Stage Configuration
export const UPDATE_FUB_STAGES = gql`
  mutation updateFubStages(
    $companyId: String!
    $activeStages: [String]!
    $closedStages: [String]!
    $ignoreStages: [String]!
  ) {
    updateFubStages(
      companyId: $companyId
      activeStages: $activeStages
      closedStages: $closedStages
      ignoreStages: $ignoreStages
    ) {
      _id
      activeStages
      closedStages
      ignoreStages
    }
  }
`;

// Trigger Manual Sync
export const TRIGGER_FUB_SYNC = gql`
  mutation triggerFubSync($companyId: String!) {
    triggerFubSync(companyId: $companyId) {
      isRunning
      progress
      totalToSync
      currentlySyncing
      errors
    }
  }
`;

// Get Unassigned Buyers (Buyer Pool)
export const GET_UNASSIGNED_BUYERS = gql`
  query getUnassignedBuyers($companyId: String!) {
    getUnassignedBuyers(companyId: $companyId) {
      _id
      firstName
      lastName
      email
      phone
      fubId
      fubSource
      fubStage
      fubSyncedAt
      leadSource
      tags
      isActive
      createdAt
    }
  }
`;

// Get Buyer Pool Count
export const GET_BUYER_POOL_COUNT = gql`
  query getBuyerPoolCount($companyId: String!) {
    getBuyerPoolCount(companyId: $companyId)
  }
`;

// Assign Buyer to Agent
export const ASSIGN_BUYER_TO_AGENT = gql`
  mutation assignBuyerToAgent($buyerId: ID!, $userId: ID!) {
    assignBuyerToAgent(buyerId: $buyerId, userId: $userId) {
      _id
      firstName
      lastName
      user {
        id
        firstName
        lastName
        email
      }
    }
  }
`;

// Unassign Buyer
export const UNASSIGN_BUYER = gql`
  mutation unassignBuyer($buyerId: ID!) {
    unassignBuyer(buyerId: $buyerId) {
      _id
      firstName
      lastName
    }
  }
`;

// Claim Buyer (Agent self-assign from pool)
export const CLAIM_BUYER = gql`
  mutation claimBuyer($buyerId: ID!) {
    claimBuyer(buyerId: $buyerId) {
      _id
      firstName
      lastName
      email
      phone
      user {
        id
        firstName
        lastName
        email
      }
    }
  }
`;

// Release Buyer (Return to pool)
export const RELEASE_BUYER = gql`
  mutation releaseBuyer($buyerId: ID!) {
    releaseBuyer(buyerId: $buyerId) {
      _id
      firstName
      lastName
    }
  }
`;

// Listing Presentation Tool - Match Buyers
export const MATCH_BUYERS_TO_PROPERTY = gql`
  query matchBuyersToPropertySpec($propertySpec: PropertySpecInput!) {
    matchBuyersToPropertySpec(propertySpec: $propertySpec) {
      totalMatches
      buyers {
        buyer {
          _id
          firstName
          lastName
          email
          phone
          user {
            _id
            firstName
            lastName
            email
          }
        }
        matchScore
        matchDetails {
          priceMatch
          bedsMatch
          bathsMatch
          sqftMatch
          locationMatch
          propertyTypeMatch
        }
      }
    }
  }
`;
